<template>
    <div id="app" class="app fond">    
        <div class="DivImageHautPageAccueil">
            <img :src="Page.image" class="ImageHautPageAccueil" :alt="'Image'+Page.page">
        </div>
        
        
        <div class="fond-page-Accueil">
            <section>
                <marquee v-if="msgImportant.length != 0 && msgImportant.actif == true && msgImportant.date_de_peremption >= dateNbr" class="message-important-accueil">
                    <h5> 
                        <svg xmlns="http://www.w3.org/2000/svg" width="30.849" height="30.849" viewBox="0 0 30.849 30.849" class="SVG-Important">
                            <path class="SVG-Info-Important" id="Icon_metro-warning" data-name="Icon metro-warning" d="M17.995,4.723,30.922,30.487H5.068L17.995,4.723Zm0-2.795a2.23,2.23,0,0,0-1.834,1.345L2.994,29.516c-1.009,1.793-.151,3.261,1.907,3.261H31.089c2.058,0,2.916-1.467,1.907-3.261h0L19.829,3.273a2.23,2.23,0,0,0-1.834-1.345Zm1.928,25.064a1.928,1.928,0,1,1-1.928-1.928A1.928,1.928,0,0,1,19.923,26.992Zm-1.928-3.856a1.928,1.928,0,0,1-1.928-1.928V15.424a1.928,1.928,0,1,1,3.856,0v5.784A1.928,1.928,0,0,1,17.995,23.136Z" transform="translate(-2.571 -1.928)"/>
                        </svg> 
                        {{msgImportant.message}}
                    </h5>
                </marquee>
            </section>

            <section class="corps-texte">
                <h1>Bienvenue sur le site de la Mairie de QUENNE</h1>

                <section class="Infos-Pratique">
                    <h3>Agenda du jour</h3>
                    <h4 style="text-align: center">{{date}}</h4>
                    <h6 v-if="this.Ferie == true"  style="text-align: center">Jour férié</h6>
                    <div class="section-cartes grid-carte">
                        <div class="encadre carte">
                            <div>
                                <img src="static/css/img/Pages/Accueil/Nuisances_sonores.jpg" alt="Nuisance sonore (tondeuse)">
                            </div>


                            <section class="contenu-carte">
                                <h5>Horaires d'utilisation d'appareils avec nuisance sonore</h5>
                                <table class="TableHoraire">
                                    <tbody>
                                        <div v-for="jour in listeHorairesNS.horaires.body.slice(0, 5)" :key="jour.id">
                                            <div v-if="jour[0].c == joursemaine && Ferie == false"><tr class="TableHoraireCol" v-for="colonne in jour.slice(1,3)" :key="colonne.id"><div v-if="colonne.c != ''">{{colonne.c}}</div></tr></div>
                                        </div>
                                        <div v-for="jour in listeHorairesNS.horaires.body.slice(5, 6)" :key="jour.id">
                                            <div v-if="joursemaine == 'Samedi' && Ferie == false"><tr class="TableHoraireCol" v-for="colonne in jour.slice(1,3)" :key="colonne.id"><div v-if="colonne.c != ''">{{colonne.c}}</div></tr></div>
                                        </div>
                                        <div v-for="jour in listeHorairesNS.horaires.body.slice(6, 7)" :key="jour.id">
                                            <div v-if="joursemaine == 'Dimanche' || Ferie == true"><tr class="TableHoraireCol" v-for="colonne in jour.slice(1,3)" :key="colonne.id"><div v-if="colonne.c != ''">{{colonne.c}}</div></tr></div>
                                        </div>
                                    </tbody>
                                </table>
                                <router-link to="/nuisance-sonore" class="button-carte">
                                    <span>EN SAVOIR +</span>
                                </router-link>
                            </section> 
                        </div>

                        <div class="encadre carte">
                            <div>
                                <img src="static/css/img/Encadres/Decheterie.JPG" alt="Mairie de QUENNE">
                            </div>

                            <section class="contenu-carte">
                                <h5>Déchèteries</h5>
                                <table v-for="Saison in listePlanningDechet" :key="Saison.id" class="TableHoraire TableHoraireDechet">
                                    <tbody v-if="jourInfini === 'Septembre' || jourInfini === 'Octobre'">
                                        <div v-if="Saison.acf.saison == 'Automne'">
                                            <div v-for="Jour in Saison.acf.Semaine" :key="Jour.jour">
                                                <div v-if="Jour.jour == joursemaine && Ferie == false && Jour.jour != 'Dimanche'">
                                                    <tr>
                                                        <th>
                                                            {{Jour.decheterie}}
                                                        </th>
                                                    </tr>
                                                    <tr v-if="Jour.horaire_matin != 'Fermé'">
                                                        {{Jour.horaire_matin}}
                                                    </tr>
                                                    <tr v-if="Jour.horaire_apres_midi != 'Fermé'">
                                                        {{Jour.horaire_apres_midi}}
                                                    </tr>
                                                </div>
                                                <div v-if="Jour.jour == 'Dimanche' && joursemaine == 'Dimanche' || Ferie == true && joursemaine == Jour.jour">
                                                    <tr>
                                                        <th>
                                                            Toutes les déchèteries sont 
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            Fermées
                                                        </th>
                                                    </tr>
                                                </div>
                                            </div>
                                        </div>
                                    </tbody>

                                    <tbody v-if="jourInfini === 'Avril' || jourInfini === 'Mai'">
                                        <div v-if="Saison.acf.saison == 'Printemps'">
                                        
                                            <div v-for="Jour in Saison.acf.Semaine" :key="Jour.jour">
                                                <div v-if="Jour.jour == joursemaine && Ferie == false && Jour.jour != 'Dimanche'">
                                                    <tr>
                                                        <th>
                                                            {{Jour.decheterie}}
                                                        </th>
                                                    </tr>
                                                    <tr v-if="Jour.horaire_matin != 'Fermé'">
                                                        {{Jour.horaire_matin}}
                                                    </tr>
                                                    <tr v-if="Jour.horaire_apres_midi != 'Fermé'">
                                                        {{Jour.horaire_apres_midi}}
                                                    </tr>
                                                </div>
                                                <div v-if="Jour.jour == 'Dimanche' && joursemaine == 'Dimanche' || Ferie == true && joursemaine == Jour.jour">
                                                    <tr>
                                                        <th>
                                                            Toutes les déchèteries sont 
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            Fermées
                                                        </th>
                                                    </tr>
                                                </div>
                                            </div>
                                        </div>
                                    </tbody>

                                    <tbody v-if=" 'Juin' === jourInfini || 'Juillet' === jourInfini || 'Août' === jourInfini">
                                        <div v-if="Saison.acf.saison === 'Été'">
                                            <div v-for="Jour in Saison.acf.Semaine" :key="Jour.jour">
                                                <div v-if="Jour.jour == joursemaine && Ferie == false && joursemaine != 'Dimanche'">

                                                    <tr>
                                                        <th>
                                                            {{Jour.decheterie}}
                                                        </th>
                                                    </tr>
                                                    <tr v-if="Jour.horaire_matin != 'Fermé'">
                                                        {{Jour.horaire_matin}}
                                                    </tr>
                                                    <tr v-if="Jour.horaire_apres_midi != 'Fermé'">
                                                        {{Jour.horaire_apres_midi}}
                                                    </tr>
                                                </div>
                                                <div v-if="Jour.jour == 'Dimanche' && joursemaine == 'Dimanche' || Ferie == true && joursemaine == Jour.jour">
                                                    <tr>
                                                        <th>
                                                            Toutes les déchèteries sont 
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            Fermées
                                                        </th>
                                                    </tr>
                                                </div>
                                            </div>
                                        </div>
                                    </tbody>

                                    <tbody v-if="'Novembre' === jourInfini || 'Décembre' === jourInfini || 'Janvier' === jourInfini || 'Février' === jourInfini || 'Mars' === jourInfini">
                                        <div v-if="Saison.acf.saison == 'Hiver'">
                                            <div v-for="Jour in Saison.acf.Semaine" :key="Jour.jour">
                                                <div v-if="Jour.jour == joursemaine && Ferie == false && Jour.jour != 'Dimanche'">
                                                    <tr>
                                                        <th>
                                                            {{Jour.decheterie}}
                                                        </th>
                                                    </tr>
                                                    <tr v-if="Jour.horaire_matin != 'Fermé'">
                                                        {{Jour.horaire_matin}}
                                                    </tr>
                                                    <tr v-if="Jour.horaire_apres_midi != 'Fermé'">
                                                        {{Jour.horaire_apres_midi}}
                                                    </tr>
                                                </div>
                                                <div v-if="Jour.jour == 'Dimanche' && joursemaine == 'Dimanche' || Ferie == true && joursemaine == Jour.jour">
                                                    <tr>
                                                        <th>
                                                            Toutes les déchèteries sont 
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            Fermées
                                                        </th>
                                                    </tr>
                                                </div>
                                            </div>
                                        </div>
                                    </tbody>
                                </table>
                                <br>
                                <router-link to="/collecte-dechet" class="button-carte">
                                    <span >EN SAVOIR +</span>
                                </router-link>
                            </section>
                        </div>

                        <div class="encadre carte">
                            <div>
                                <img src="static/css/img/Pages/Accueil/Mairie.jpg" alt="Mairie de QUENNE">
                            </div>

                            <section class="contenu-carte">
                                <h5>Horaires du secrétariat de Mairie</h5>
                                <table class="TableHoraire">
                                    <tbody>
                                        <div v-if="Ferie == false && horaireSpe == false">
                                            <div v-for="jour in Mairie.horaires.body" :key="jour[0].c">
                                                <div v-if="jour[0].c == joursemaine">
                                                    <tr class="TableHoraireCol" v-for="colonne in jour.slice(1,3)" :key="colonne.id">
                                                        <div v-if="colonne.c != ''">
                                                            {{colonne.c}}
                                                        </div>
                                                    </tr>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="horaireSpe != false && horaireSpe.sujet_absence == 'Horaires exceptionnels'">
                                            <tr>
                                                <div><i style="color:#F2F2F2">Horaires exceptionnels</i></div>
                                                <div v-if="horaireSpe.horaires_matin != 'Fermé' || horaireSpe.horaires_matin != 'fermé' || horaireSpe.horaires_matin != 'ferme' || horaireSpe.horaires_matin != 'Ferme'">{{horaireSpe.horaires_matin}}</div>
                                                <div v-if="horaireSpe.horaires_matin != 'Fermé' || horaireSpe.horaires_matin != 'fermé' || horaireSpe.horaires_matin != 'ferme' || horaireSpe.horaires_matin != 'Ferme'">{{horaireSpe.horaires_aprem}}</div>
                                            </tr>

                                        </div>
                                        <div v-if="horaireSpe != false && horaireSpe.sujet_absence == 'Vacances'">
                                            <tr>
                                                <div><i style="color:#F2F2F2">Horaires exceptionnels</i></div>
                                                <div>Secrétaire en congé</div>
                                            </tr>

                                        </div>
                                        <div v-if="horaireSpe != false && horaireSpe.sujet_absence == 'Fermeture exceptionnelle'">
                                            <tr>
                                                <div><i style="color:#F2F2F2">Horaires exceptionnels</i></div>
                                                <div>Fermeture exceptionnelle</div>
                                            </tr>

                                        </div>
                                        <div v-if="Ferie == true">
                                            <tr class="TableHoraireCol"><div>Férié</div></tr>
                                        </div>
                                    </tbody>
                                </table>
                                <router-link to="/contact" class="button-carte">
                                    <span>EN SAVOIR +</span>
                                </router-link>
                            </section>
                        </div>
                    </div>
                </section>

                <section>
                    <h3>Alertes et restrictions en cours</h3>
                    <h6 v-if="this.compteAlerte == 0" style="text-align: center">Aucune alerte ou restriction en cours</h6>
                    <div class="section-alerte">
                        <div class="section-logo-alerte">
                            <div class="alerte" v-for="alerte in listeAlertes" :key="alerte.type_alerte">
                                <div v-if="alerte.type_alerte == 'Inondation' && alerte.niveau != 'Inactif'">

                                    <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <path d="M256,0C114.62,0,0,114.62,0,256s114.62,256,256,256,256-114.62,256-256S397.38,0,256,0Zm-101.55,192.46l91.74-66.7c5.84-4.25,13.76-4.25,19.6,0l91.73,66.7c5.84,4.27,8.29,11.78,6.05,18.66-2.24,6.88-8.6,11.52-15.84,11.52h-8.65l.16,38.15c-.83,.47-1.62,.99-2.35,1.51-9.38,6.46-20.95,10.63-30.85,10.63s-21.26-4.01-30.85-10.63c-11.47-8.08-26.84-8.08-38.36,0-8.96,6.15-19.8,10.63-30.85,10.63-10.37,0-21.47-4.17-30.8-10.63-.83-.57-1.67-1.56-2.55-1.62v-38.05h-8.34c-7.22,0-13.62-4.64-15.86-11.52-2.24-6.88,.21-14.38,6.05-18.66Zm251.22,184.08c-2.08,8.96-11.52,14.54-20.07,12.46-12.77-3.02-23.35-8.65-30.33-13.03-15.11,8.08-32.05,13.45-49.25,13.45s-31.58-5.16-41.9-9.85c-3.07-1.36-5.79-2.76-8.13-4.01-2.35,1.25-5.06,2.66-8.13,4.01-10.32,4.69-25.28,9.85-41.9,9.85-17.67,0-34.14-5.37-49.25-13.45-6.97,4.38-17.57,10.01-30.35,13.03-8.97,2.08-17.94-3.49-20.03-12.46-2.09-8.96,3.49-17.98,12.46-20.07,9.43-2.19,18.88-6.93,26.36-13.13,5.81-4.95,14.22-5.32,20.43-.89h.05c11.52,7.97,26.32,13.6,40.34,13.6s28.66-5.52,40.39-13.6c5.79-4.12,13.5-4.12,19.28,0,11.26,8.08,26.06,13.6,40.39,13.6s28.87-5.63,40.34-13.6h.05c6.2-4.43,14.59-4.07,20.43,.89,7.45,6.2,16.94,10.94,26.37,13.13,8.96,2.08,14.54,11.1,12.46,20.07Zm0-58.37c-2.08,8.96-11.52,14.54-20.07,12.46-12.77-3.02-23.35-8.65-30.33-13.03-15.11,8.08-32.05,13.45-49.25,13.45s-31.58-5.16-41.9-9.85c-3.07-1.36-5.79-2.76-8.13-4.01-2.35,1.25-5.06,2.66-8.13,4.01-10.32,4.69-25.28,9.85-41.9,9.85-17.67,0-34.14-5.37-49.25-13.45-6.97,4.38-17.57,10.01-30.35,13.03-8.97,2.08-17.94-3.49-20.03-12.46-2.09-8.96,3.49-17.98,12.45-20.07,9.43-2.19,18.88-6.93,26.36-13.13,5.81-4.95,14.22-5.32,20.43-.89h.05c11.52,7.97,26.32,13.6,40.34,13.6s28.66-5.52,40.39-13.6c5.79-4.12,13.5-4.12,19.28,0,11.26,8.08,26.06,13.6,40.39,13.6s28.87-5.63,40.34-13.6h.05c6.2-4.43,14.59-4.07,20.43,.89,7.45,6.2,16.94,10.94,26.37,13.13,8.96,2.08,14.54,11.1,12.46,20.07Z"/>
                                    </svg>
                                    <h4>{{alerte.type_alerte}}</h4>
                                    <p style="text-align: center">{{alerte.niveau}}</p>
                                </div>

                                <div v-if="alerte.type_alerte == 'Canicule' && alerte.niveau != 'Inactif'">
                                    <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <path d="M256,0C114.62,0,0,114.62,0,256s114.62,256,256,256,256-114.62,256-256S397.38,0,256,0Zm61.75,183.74l40.19-40.45c2.77-2.79,7.28-2.81,10.07-.03s2.81,7.28,.03,10.07l-40.19,40.45c-2.77,2.79-7.28,2.81-10.07,.03-2.79-2.77-2.81-7.28-.03-10.07Zm-62.27-86.67c3.93-.01,7.13,3.17,7.15,7.1l.19,57.02c.01,3.93-3.17,7.13-7.1,7.15-3.93,.01-7.13-3.17-7.15-7.1l-.19-57.02c-.01-3.93,3.17-7.13,7.1-7.15Zm-112.23,46.91c2.77-2.79,7.28-2.81,10.07-.03l40.45,40.19c2.79,2.77,2.81,7.28,.03,10.07h0c-2.77,2.79-7.28,2.81-10.07,.03l-40.45-40.19c-2.79-2.77-2.81-7.28-.03-10.07Zm-46.18,112.53c-.01-3.93,3.17-7.13,7.1-7.15l57.02-.19c3.93-.01,7.13,3.17,7.15,7.1,.01,3.93-3.17,7.13-7.1,7.15l-57.02,.19c-3.93,.01-7.13-3.17-7.15-7.1Zm97.18,71.75l-40.19,40.45c-2.77,2.79-7.28,2.81-10.07,.03-2.79-2.77-2.81-7.28-.03-10.07l40.19-40.45c2.77-2.79,7.28-2.81,10.07-.03h0c2.79,2.77,2.81,7.28,.03,10.07Zm62.27,86.67c-3.93,.01-7.13-3.17-7.15-7.1l-.19-57.02c-.01-3.93,3.17-7.13,7.1-7.15h0c3.93-.01,7.13,3.17,7.15,7.1l.19,57.02c.01,3.93-3.17,7.13-7.1,7.15Zm-.52-93.17c-36.27,0-65.76-29.49-65.76-65.76s29.49-65.76,65.76-65.76,65.76,29.49,65.76,65.76-29.49,65.76-65.76,65.76Zm112.75,46.26c-2.77,2.79-7.28,2.81-10.07,.03l-40.45-40.19c-2.79-2.77-2.81-7.28-.03-10.07s7.28-2.81,10.07-.03l40.45,40.19c2.79,2.77,2.81,7.28,.03,10.07Zm39.08-105.38l-57.02,.19c-3.93,.01-7.13-3.17-7.15-7.1h0c-.01-3.93,3.17-7.13,7.1-7.15l57.02-.19c3.93-.01,7.13,3.17,7.15,7.1,.01,3.93-3.17,7.13-7.1,7.15Z"/>
                                        <circle cx="256" cy="256" r="32.88" transform="translate(-106.04 256) rotate(-45)"/>
                                    </svg>
                                    <h4>{{alerte.type_alerte}}</h4>
                                    <p style="text-align: center">{{alerte.niveau}}</p>
                                </div>

                                <div v-if="alerte.type_alerte == 'Incendie' && alerte.niveau != 'Inactif'">
                                    <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <path d="M281.58,273.24s-53.88-68.84-57.98-73.53c-28.44,34.1-42.65,54.05-42.65,76.7,0,45.43,34.46,73.41,76.76,73.41,16.95,0,32.54-5.28,45.27-14.13,28.91-20.23,35.65-59.4,19.58-90-1.98-3.74-4.17-7.71-6.59-11.67l-34.38,39.22Z"/><path d="M256,0C114.62,0,0,114.62,0,256s114.62,256,256,256,256-114.62,256-256S397.38,0,256,0Zm0,406.11c-72.59,0-131.35-60.45-131.35-135.1,0-41.98,40.9-111.69,98.51-165.12,22.4,20.82,42.28,43.17,58.28,65.15,9.73-11.93,20.76-23.81,32.9-35.09,42.51,39.43,73,103.87,73,135.07,0,74.64-58.75,135.1-131.35,135.1Z"/>
                                    </svg>
                                    <h4>{{alerte.type_alerte}}</h4>
                                    <p style="text-align: center">{{alerte.niveau}}</p>
                                </div>

                                <div v-if="alerte.type_alerte == 'Sécheresse' && alerte.niveau != 'Inactif'">
                                    <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" :style="'fill:'+alerte.couleur">
                                        <circle cx="155.41" cy="200.62" r="18.15" transform="translate(-30.13 27.48) rotate(-9.22)"/>
                                        <path d="M256,0C114.62,0,0,114.62,0,256s114.62,256,256,256,256-114.62,256-256S397.38,0,256,0Zm-12.86,200.34c0,2.17-1.75,3.94-3.92,3.95l-31.48,.1c-2.17,0-3.94-1.75-3.95-3.92,0-2.17,1.75-3.94,3.92-3.95l31.48-.1c2.17,0,3.94,1.75,3.95,3.92Zm-25.49,62.12c-1.53,1.54-4.02,1.55-5.56,.02l-22.33-22.18c-1.54-1.53-1.55-4.02-.02-5.56,1.53-1.54,4.02-1.55,5.56-.02l22.33,22.18c1.54,1.53,1.55,4.02,.02,5.56Zm-28.15-101.72l22.18-22.33c1.53-1.54,4.02-1.55,5.56-.02s1.55,4.02,.02,5.56l-22.18,22.33c-1.53,1.54-4.02,1.55-5.56,.02h0c-1.54-1.53-1.55-4.02-.02-5.56Zm-34.37-47.84h0c2.17,0,3.94,1.75,3.95,3.92l.1,31.48c0,2.17-1.75,3.94-3.92,3.95-2.17,0-3.94-1.75-3.95-3.92l-.1-31.48c0-2.17,1.75-3.94,3.92-3.95Zm.28,51.43c20.02,0,36.3,16.28,36.3,36.3s-16.28,36.3-36.3,36.3-36.3-16.28-36.3-36.3,16.28-36.3,36.3-36.3Zm4.2,120.08c0,2.17-1.75,3.94-3.92,3.95-2.17,0-3.94-1.75-3.95-3.92l-.1-31.48c0-2.17,1.75-3.94,3.92-3.95,2.17,0,3.94,1.75,3.95,3.92l.1,31.48Zm-38.29-43.89l-22.18,22.33c-1.53,1.54-4.02,1.55-5.56,.02-1.54-1.53-1.55-4.02-.02-5.56l22.18-22.33c1.53-1.54,4.02-1.55,5.56-.02h0c1.54,1.53,1.55,4.02,.02,5.56Zm-28.15-101.72c1.53-1.54,4.02-1.55,5.56-.02l22.33,22.18c1.54,1.53,1.55,4.02,.02,5.56-1.53,1.54-4.02,1.55-5.56,.02l-22.33-22.18c-1.54-1.53-1.55-4.02-.02-5.56Zm-21.55,66.04c-2.17,0-3.94-1.75-3.95-3.92,0-2.17,1.75-3.94,3.92-3.95l31.48-.1c2.17,0,3.94,1.75,3.95,3.92,0,2.17-1.75,3.94-3.92,3.95l-31.48,.1Zm354.54,194.27H99.49c-10.02,0-18.15-8.11-18.15-18.15s8.13-18.15,18.15-18.15h240.48v-99.82c0-10.04-8.11-18.15-18.15-18.15s-18.15,8.11-18.15,18.15v12.14c8.39,4.37,13.61,13.1,13.61,25.3,0,10.95-12.19,29.55-27.22,44.24-15.03-14.69-27.22-33.12-27.22-44.24,0-12.19,5.22-20.93,13.61-25.3v-12.65c0-24.56,20.3-45.37,45.37-45.37,6.47,0,12.59,1.87,18.15,4.31v-13.38c0-24.56,20.3-45.37,45.37-45.37s45.37,20.81,45.37,45.37v30.8c8.39,4.37,13.61,13.1,13.61,25.3,0,10.95-12.19,29.55-27.22,44.24-15.03-14.69-27.22-33.12-27.22-44.24,0-12.19,5.22-20.93,13.61-25.3v-30.8c0-9.53-8.11-18.15-18.15-18.15s-18.15,8.62-18.15,18.15v154.78h58.98c10.04,0,18.15,8.11,18.15,18.15s-8.11,18.15-18.15,18.15Z"/>
                                    </svg>
                                    <h4 :style="'color:'+alerte.couleur">{{alerte.type_alerte}}</h4>
                                    <p :style="'text-align: center; color:'+alerte.couleur">{{alerte.niveau}}</p>
                                </div>

                                <div v-if="alerte.type_alerte == 'Chimique' && alerte.niveau != 'Inactif'">
                                    <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <rect x="137.62" y="154.54" width="33.82" height="50.73"/>
                                        <path d="M323.64,239.09v-84.55h-33.82v84.55c0,3.12-.85,6.18-2.48,8.88l-25.79,41.85h90.37l-25.79-41.85c-1.64-2.7-2.48-5.76-2.48-8.88Z"/>
                                        <path d="M256,0C114.62,0,0,114.62,0,256s114.62,256,256,256,256-114.62,256-256S397.38,0,256,0Zm-84.55,354.56c-5.76,1.9-10.99,2.91-16.91,2.91-28.02,0-50.73-22.72-50.73-50.73V154.54c-9.34,0-16.91-7.57-16.91-16.91s7.57-16.91,16.91-16.91h101.46c9.35,0,16.91,7.57,16.91,16.91s-7.56,16.91-16.91,16.91v129.95l-25.89,42.01c-5.18,8.46-7.93,18.18-7.93,28.06Zm216.99,36.73H225.03c-20.24,0-37.15-16.44-37.15-36.68,0-6.82,2.38-13.42,5.92-19.24l61.72-101.09v-79.74c-8.88,0-16.91-7.57-16.91-16.91s8.03-16.91,16.91-16.91h101.94c9.35,0,16.91,7.57,16.91,16.91s-7.56,16.91-16.91,16.91v79.74l62.2,101.09c3.54,5.81,5.44,12.42,5.44,19.24,0,20.24-16.44,36.68-36.68,36.68Z"/>
                                    </svg>
                                    <h4>{{alerte.type_alerte}}</h4>
                                    <p style="text-align: center">{{alerte.niveau}}</p>
                                </div>

                                <div v-if="alerte.type_alerte == 'Nucléaire' && alerte.niveau != 'Inactif'">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <path d="M226.4 208.6L184.8 141.9C179.6 133.7 168.3 132 160.7 138.2C130.8 162.3 110.1 197.4 105.1 237.4C103.9 247.2 111.2 256 121 256H200C200 236 210.6 218.6 226.4 208.6zM256 288c17.67 0 32-14.33 32-32s-14.33-32-32-32C238.3 224 224 238.3 224 256S238.3 288 256 288zM285.6 303.3C276.1 308.7 266.9 312 256 312c-10.89 0-20.98-3.252-29.58-8.65l-41.74 66.8c-5.211 8.338-1.613 19.07 7.27 23.29C211.4 402.7 233.1 408 256 408c22.97 0 44.64-5.334 64.12-14.59c8.883-4.219 12.48-14.95 7.262-23.29L285.6 303.3zM351.4 138.2c-7.604-6.145-18.86-4.518-24.04 3.77l-41.71 66.67C301.4 218.6 312 236 312 256h78.96c9.844 0 17.11-8.791 15.91-18.56C401.9 197.5 381.3 162.4 351.4 138.2zM256 16C123.4 16 16 123.4 16 256s107.4 240 240 240c132.6 0 240-107.4 240-240S388.6 16 256 16zM256 432c-97.05 0-176-78.99-176-176S158.1 80 256 80s176 78.95 176 176S353 432 256 432z"/>
                                    </svg>
                                    <h4>{{alerte.type_alerte}}</h4>
                                    <p style="text-align: center">{{alerte.niveau}}</p>
                                </div>
                            </div>
                        </div>
                        <div v-for="alerte in listePDFAlerte" :key="alerte.type_alerte">
                            <div class="carte" v-if="alerte.niveau === 'Afficher'">
                                <iframe class="iframe-carte" :src="alerte.pdf.url" frameborder="0"></iframe>
                            </div>
                        </div>
                    </div>
                </section>
                
                <section class="Derniere-actus">
                    <h3>Dernières actualités</h3>
                    
                    <div class="section-cartes grid-carte">
                        <div class="encadre carte" v-for="actualite in ActuFilterByDate.slice(0, 2)" :key="actualite.id">
                            <div v-if="actualite.image != ''">
                                <img :src="actualite.image" alt="Mairie de QUENNE">
                            </div>

                            <section class="contenu-carte">
                                <h5>{{actualite.titre}}</h5>
                                <p><span v-html="actualite.textereduit"></span></p>
                                <router-link :to="{name: 'Publication', params: {id : actualite.id}}" class="button-carte">
                                    <span >EN SAVOIR +</span>
                                </router-link>
                            </section>
                        </div>
                        <iframe src="https://app.panneaupocket.com/embeded/192721193" height="364" width="264" frameborder="0"></iframe>
                    </div>
                </section>

                <div class="button">
                    <router-link to="/agenda">Toutes les actualités</router-link>
                </div>
                <br>

                <h3>Calendrier des évènements</h3>

                <div class="CalendarAccueil">
                    <iframe src="https://calendar.google.com/calendar/u/0/embed?src=gku4k11npjotglk710acut19es@group.calendar.google.com&ctz=Europe/Paris" class="" style="border: 0" width="100%" height="100%" frameborder="0" scrolling="no"></iframe>
                </div>

                    
                <div class="encadre encadre-Mairie">
                    <div>
                        <img :src="Mairie.image.url" alt="Mairie Quenne">
                    </div>

                    <section class="Info-Mairie" v-if="Mairie.length != 0">
                        <h5>Mairie</h5>
                        
                        <section>
                            <h6 class="titre-section-encadre">Horaires du secrétariat</h6>
                            <i class="titre-section-encadre">Horaires par défaut.</i>
                            <table>
                                <tbody>
                                    <tr v-for="jour in Mairie.horaires.b" :key="jour.id">
                                        <th v-for="colonne in jour" :key="colonne.id">{{colonne.c}}</th>
                                    </tr>
                                </tbody>
                            </table>
                            <h6 class="titre-section-encadre">Contact</h6>
                            <table>
                                <tbody>
                                    <tr>
                                        <th>Tel</th>
                                        <th>{{Mairie.telephone}}</th>
                                    </tr>
                                    <tr>
                                        <th>e-mail</th>
                                        <th><a :href="'mailto:' + Mairie.email" class="lien-encadre">{{Mairie.email}}</a></th>
                                    </tr>
                                </tbody>
                            </table>
                            <table>
                                <tbody>
                                    <tr>
                                        <th>Adresse</th>
                                        <th>{{Mairie.adresse}}<br> </th>
                                    </tr>
                                    <tr>
                                        <th colspan="2">{{Mairie.complement_adresse}}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                    </section>
                    <iframe class="map-encadre" :src="Mairie.lien_adresse_iframe" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>

                <div class="encadre encadre-Mairie" v-for="Mairie in listeMairies" :key="'Mairie-2-'+Mairie.id">
                    <div>
                        <img :src="Mairie.image_dae.url" alt="Mairie Quenne">
                    </div>

                    <section class="Info-Mairie" v-if="Mairie.length != 0">
                        <h5>DAE</h5>
                        
                        <section>
                            <h6 class="titre-section-encadre">Défibrilateur</h6>
                            <table>
                                <tbody>
                                    <tr>
                                        <th>24h/7j</th>
                                    </tr>
                                </tbody>
                            </table>
                            <h6 class="titre-section-encadre">Où le trouver</h6>
                            <table>
                                <tbody>
                                    <tr>
                                        <th>Adresse</th>
                                        <th>{{Mairie.adresse}}<br> </th>
                                    </tr>
                                    <tr>
                                        <th colspan="2">{{Mairie.complement_adresse_dae}}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                        <iframe class="map-aed" :src="Mairie.lien_adresse_iframe_dae" allowfullscreen="yes" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </section>
                    <section class="section-Num">
                        <h3 style="color: red; padding-top: 20px">Numéros importants</h3>

                        <section class="numeros droite">
                            <table>
                                <tbody>
                                    <tr>
                                        <th colspan="2"><h6>Numéros d'urgence</h6></th>
                                    </tr>
                                    <tr v-for="numero in listeNumeros" :key="numero.id">
                                        <th v-if="numero.type == 'Urgence'" style="width: 75%"><p style="text-align:left">{{numero.entite}}</p></th>
                                        <th v-if="numero.type == 'Urgence'" style="width: 25%"><a :href="'tel:'+numero.numero" :style="'background-color:' + numero.couleur + '; color:'+numero.couleur_font" class="numero-urgence">{{numero.numero}}</a></th>
                                    </tr>
                                </tbody>
                            </table>
                        </section>

                        <section class="numeros droite">
                            <table>
                                <tbody>
                                    <tr>
                                        <th colspan="2"><h6>Numéros utiles</h6></th>
                                    </tr>
                                    <tr v-for="numero in listeNumeros" :key="numero.id">
                                        <th v-if="numero.type == 'Numéro Utile'" style="width: 50%"><p style="text-align:left">{{numero.entite}}</p></th>
                                        <th v-if="numero.type == 'Numéro Utile'" style="width: 25%"><p style="text-align:left"><i>{{numero.legende}}</i></p></th>
                                        <th v-if="numero.type == 'Numéro Utile'" style="width: 25%"><a :href="'tel:'+numero.numero" :style="'background-color:' + numero.couleur + '; color:'+numero.couleur_font" class="numero-urgence">{{numero.numero}}</a></th>
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                        <div v-for="numero in listeNumeros" :key="numero.id" class="numeros droite">
                            <p v-if="numero.nom_complet != ''" style="padding: 0 20px">{{numero.entite}} = {{numero.nom_complet}}</p>
                        </div>
                    </section>
                </div>


               

                <section class="Infos-Pratiques">
                    <div class="section-cartes">
                        <div v-if="motMaire.length != 0">
                            <h4>Le mot du maire</h4>
                            <p v-html="motMaire[0].paragraphe" class="paragraphe"></p>
                            <section class="div-auteur" v-for="elu in listeElus" :key="elu.id">
                                <span class="auteur" v-if="elu.id == motMaire[0].maire[0]">{{elu.prenom}} {{elu.nom}}</span>
                            </section>
                        </div>

                    </div>
                </section>
            </section>
        </div>
    </div>
</template>

<script>
import param from '@/param/param'

export default {
    name: 'Accueil',
    data () {
        return{
            listeMairies:[],
            Mairie: {},
            listeJourFerie:[],
            listeNumeros:[],
            listePDFAlerte: [],
            msgImportant:[],
            motMaire:[],
            listeElus:[],
            listeActualites:[],
            listeActualitesFuture: [],
            listeHorairesNS:[],
            date: null,
            time: null,
            joursemaine: null,
            datejour: null,
            listePlanningDechet: [],
            listeHoraireMairieSpe:[],
            horaireTableau: 0,
            horaireSpe: false,
            compaDate: false,
            i: 0,
            Ferie : false,
            jourInfini: 0,
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            },
            listeAlertes:[],
            dateNbr: 0,
            compteAlerte: 0,
        }
    }, 

    created(){
       var currentdate = new Date();
        var date = new Date;
        var annee = date.getFullYear();
        var moi = date.getMonth();
        var mois = new Array('Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre');
        var moisnumerique = new Array('01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12');
        

        var j = date.getDate();
        if(j < 10){
            j = '0'+j
        }
        var jour = date.getDay();
        var jours = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');
        this.date = jours[jour]+' '+j+' '+mois[moi]+' '+annee+'';
        this.timeFull = currentdate.getHours()+" h "+currentdate.getMinutes()+" min "+currentdate.getSeconds()+" sec";
        this.time = currentdate.getHours()+" h "+currentdate.getMinutes()+" min ";
        this.joursemaine = jours[jour];
        this.datejour = +j+'/'+moi;
        this.dateJourNum = j+'/'+moisnumerique[moi]+'/'+annee;
        this.dateJourCompa = annee+'-'+moisnumerique[moi]+'-'+j
        this.dateJourCompaChiffre = annee+moisnumerique[moi]+j
        this.jourInfini = mois[moi];
        this.dateNbr = annee+''+moisnumerique[moi]+''+j


        axios.get(param.host+'mairie/v1/listeMairies')
        .then(response =>{
            this.listeMairieAxios = response.data;

            let mairie = new Array

            for(let i = 0; this.listeMairieAxios.length > i; i++){
                if(this.listeMairieAxios[i].id === 28872){
                    mairie = this.listeMairieAxios[i]
                }
            }

            this.Mairie = mairie
        })
        .catch(error => console.log(error))

        axios.get('https://calendrier.api.gouv.fr/jours-feries/metropole/'+annee+'.json')
        .then(response =>{
            this.listeJourFerie = response.data;

            this.json = [];
            var i = 0;
            let jourferie = null;
            for(jourferie in this.listeJourFerie){
                let test = jourferie.split('-');
                let dateJourCompaSplit = this.dateJourCompa.split('-');
                let dateJourCompaNum = dateJourCompaSplit[0]+dateJourCompaSplit[1]+dateJourCompaSplit[2]
                let dateferieCompa = test[0]+test[1]+test[2];
                let datefr = test[2]+'/'+test[1]+'/'+test[0];
                if(dateferieCompa == dateJourCompaNum){
                    this.Ferie = true;
                }else{
                    this.Ferie = false
                }

                this.json[i] = datefr;

                if(this.Ferie == true){
                    return this.Ferie
                }

                i++;

            }
        })
        .catch(error => console.log(error))

        axios.get(param.host+'numero/v1/listeNumeros')
        .then(response =>{
            this.listeNumeros = response.data;
        })
        .catch(error => console.log(error))

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'Accueil'){
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))

        axios.get(param.host+'horaireMairieSpe/v1/listeHoraireMairieSpe')
        .then(response =>{
            this.listeHoraireMairieSpe = response.data;
            console.log('horaire', this.listeHoraireMairieSpe)
            this.horaireSpe = false
            for(var i = 0; this.listeHoraireMairieSpe.length > i; i++){
                this.SplitDateDebut = new Array
                this.SplitDateDebut = this.listeHoraireMairieSpe[i].date.split('-');
                this.DateCompaDebut = Number(this.SplitDateDebut[0]+this.SplitDateDebut[1]+this.SplitDateDebut[2])
                if(this.DateCompaDebut <= this.dateJourCompaChiffre - 1){
                    this.horaireSpe = false
                }else if(this.DateCompaDebut >= this.dateJourCompaChiffre && this.listeHoraireMairieSpe[i].date_de_fin == null){
                    if(this.DateCompaDebut == this.dateJourCompaChiffre){
                        return this.horaireSpe = this.listeHoraireMairieSpe[i]
                    }else{
                        this.horaireSpe = false;
                    }
                }else{
                    this.SplitDateFin = new Array
                    this.SplitDateFin = this.listeHoraireMairieSpe[i].date_de_fin.split('-');
                    this.DateCompaFin = this.SplitDateFin[0]+this.SplitDateFin[1]+this.SplitDateFin[2]
                    if(this.DateCompaDebut <= this.dateJourCompaChiffre){
                        if(this.DateCompaFin >= this.dateJourCompaChiffre){
                            this.horaireSpe = this.listeHoraireMairieSpe[i]
                        }
                    }else{
                        this.horaireSpe = false;
                    }
                }
            }
        })
        .catch(error => console.log(error))
        
        axios.get(param.host+'message_important/v1/listeMessagesImportants')
        .then(response =>{
            this.listeMessagesImportants = response.data;

            let MessageImportant = new Array

            for(let i = 0; this.listeMessagesImportants.length > i; i++){
                if(this.listeMessagesImportants[i].actif === true && this.listeMessagesImportants[i].date_de_peremption > this.dateNbr){
                    MessageImportant = this.listeMessagesImportants[i]
                }
            }

            this.msgImportant = MessageImportant
        })
        .catch(error => console.log(error))

        axios.get(param.host+'alerte/v1/listeAlertes')
        .then(response =>{
            this.listeAlertes = response.data;
            let pdfAlerte = new Array()

            for(var i = 0; this.listeAlertes.length > i; i++){
                if(this.listeAlertes[i].type_alerte === "Sécheresse"){
                    if(this.listeAlertes[i].niveau == "Crise"){
                        this.listeAlertes[i].couleur = '#F10D0C'
                    }if(this.listeAlertes[i].niveau == "Alerte renforcée"){
                        this.listeAlertes[i].couleur = '#FE860E'
                    }if(this.listeAlertes[i].niveau == "Alerte"){
                        this.listeAlertes[i].couleur = '#FDC500'
                    }if(this.listeAlertes[i].niveau == "Vigilance"){
                        this.listeAlertes[i].couleur = '#B2B2B2'
                    }
                }else if(this.listeAlertes[i].type_alerte === "Fichier PDF Préfecture"){
                    pdfAlerte[0] = this.listeAlertes[i]
                }

                this.listePDFAlerte = pdfAlerte

                if(this.listeAlertes[i].niveau != "Inactif"){
                    this.compteAlerte++
                }
            }

            
        })
        .catch(error => console.log(error))

        axios.get(param.host+'motMaire/v1/listeMotMaire')
        .then(response =>{
            this.motMaire = response.data;
        })
        .catch(error => console.log(error))

        axios.get(param.host+'actualite/v1/listeActualites')
        .then(response =>{
            this.listeActualites = response.data;
            let actu = new Array
            let j = 0
            for(var i = 0; this.listeActualites.length > i; i++){
                this.dateSplit = this.listeActualites[i].date.split('/');
                this.listeActualites[i].date_comparaison = this.dateSplit[2]+'-'+this.dateSplit[1]+'-'+this.dateSplit[0];

                this.listeActualites[i].textereduit = this.listeActualites[i].texte.substring(0, 150) + '...';
                
                if(this.listeActualites[i].date_comparaison >= this.dateJourCompa){
                    actu[j] = this.listeActualites[i]
                    j++;
                }
            }
            
            this.listeActualitesFuture = actu;
        })
        .catch(error => console.log(error))

        axios.get(param.host+'elu/v1/listeElus')
        .then(response =>{
            this.listeElus = response.data;
        })
        .catch(error => console.log(error))

        axios.get(param.host+'nuisance_sonore/v1/listeNS')
        .then(response =>{
            this.listeHorairesNSAxios = response.data;

            let HoriareNS = new Array

            for(let i = 0; this.listeHorairesNSAxios.length > i; i++){
                if(this.listeHorairesNSAxios[i].id === 29040){
                    HoriareNS = this.listeHorairesNSAxios[i]
                }
            }

            this.listeHorairesNS = HoriareNS
        })
        .catch(error => console.log(error))

        axios.get(param.hostacf+'decheterie')
        .then(response =>{
            this.listePlanningDechet = response.data;
        })
        .catch(error => console.log(error))
    },

    computed:{
        ActuFilterByDate: function(){
            function compare(a, b){
                if(a.date_comparaison < b.date_comparaison) return -1
                if(a.date_comparaison > b.date_comparaison) return 1
                return 0
            }
            return this.listeActualitesFuture.sort(compare)
        }
    }
}
</script>

<style scoped>
#app{
    position: relative;
    z-index: 0;
}
.DivImageHautPageAccueil{
    width: 100vw;
    height: 80vh;
    position: fixed;
    overflow: hidden;
    border-radius: 0;
    top: 0;
    left: 0;
    z-index: -10;
}

@media(min-width: 1401px){
    .DivImageHautPageAccueil>img{
        min-width: 100%;
        max-width: 120%;
        height: auto;
        min-height: 100%;
        position: relative;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        border-radius: 0;
    }
}

@media(max-width: 1400px){
    .DivImageHautPageAccueil>img{
        min-width: auto;
        height: 100%;
        position: relative;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        border-radius: 0;
    }
}

.fond-page-Accueil{
    background-color: #F2F2F2;
    margin-top: 80vh;
    z-index: 1;
    width: 100vw;
}

</style>




// WEBPACK FOOTER //
// src/components/Accueil.vue